import { MLHelper } from '@bimser/core';
import IconAction from '@bimser/icons/16/action';
import GetIcon16ByName from '@bimser/icons/lib/getIcon16ByName';
import * as React from 'react';
import DataGrid2 from '..';
import { onColumnActionButtonClick } from '../helpers';

const openTypes = ['OpenProcessArgs', 'OpenFormArgs'];

const style: React.CSSProperties = {
	cursor: 'pointer'
};

const disabledStyle: React.CSSProperties = {
	cursor: 'not-allowed',
	opacity: '0.6'
};

export const ActionButton = React.memo<any>(props => {
	const bcDataGrid: DataGrid2 = props.data.column.retrieveDataGridInstance();
	const bcColumn = bcDataGrid.__getBCColumn(props.data.column.name);

	const isDisabled = () => {
		if (openTypes.includes(bcColumn.actionButtonProps.typeName)) {
			return bcDataGrid.__isDisabled();
		}

		if (bcColumn.actionButtonProps.args.editable) {
			return bcDataGrid.__isReadOnly() || bcDataGrid.__isDisabled();
		}

		return false;
	};

	const onClick = () => {
		onColumnActionButtonClick(bcDataGrid, bcColumn, props.data.data);
	};

	const Icon = GetIcon16ByName(bcColumn.actionButtonProps.icon, IconAction);

	return (
		<Icon
			style={isDisabled() ? disabledStyle : style}
			onClick={onClick}
			title={MLHelper.getMLText(bcColumn.actionButtonProps.title)}
		/>
	);
});
